import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, shallowEqual } from 'react-redux';
import { ThemeContext } from '../../context/ThemeContext';
import { TextField } from '@mui/material';

export const profitLoss = new Map();

export const SetPLValue = (id, value) => {
  profitLoss.set(id, value);
}

export const deletePLValue = (id) => {
  profitLoss.delete(id);
}
export const clearPL = () => {
  profitLoss.clear();
};

function AccountFooter({ searchQuery, setSearchQuery, selectedType, handleMenuItemClick }) {
  const { t } = useTranslation()
  const { accountSummary = [] } = useSelector(state => state.accountSummary, shallowEqual)
  const { updatePL } = useSelector((state) => state.profitLoss);
  const [floatingPL, setFloatingPL] = useState(0)
  const { darkMode } = useContext(ThemeContext)
  const fallbackUsedMArgin = accountSummary?.marginLevel === 1 ? '100.00' : '0.00'
  const calculatedEquity = accountSummary.balance ? (parseFloat(accountSummary.balance) + parseFloat(floatingPL) + (accountSummary?.credit))?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00';
  const calculatedMarginLevel = calculatedEquity && accountSummary.usedMargin ? ((parseFloat(accountSummary.balance) + parseFloat(floatingPL) + (accountSummary?.credit)) / parseFloat(accountSummary.usedMargin) * 100)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : fallbackUsedMArgin;
  const freeMargin = calculatedEquity ? (parseFloat(accountSummary.balance) + parseFloat(floatingPL) - parseFloat(accountSummary.usedMargin) + (accountSummary?.credit))?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00';
  const { accountId: accountID } = useSelector(state => state.accountSummary)
  const accountId = localStorage.getItem("accountID") || accountID;
  useEffect(() => {
    let pl = 0;

    for (const [key, value] of profitLoss) {
      if (key.startsWith(`${accountId}-`)) {
        pl += parseFloat(value) || 0;
      }
    }

    setFloatingPL(pl);
  }, [updatePL, accountId]);

  // console.log(accountSummary?.marginLevel);

  const imgSrc = darkMode ? '/hs-white.png' : '/hs-logo.png'
  return (
    <div className='flex items-center px-1 justify-between' style={{ backgroundColor: darkMode ? "#151924" : "#fff", color: darkMode ? 'var(--lightText)' : 'var(--darkText)', height: 30 }}>
      <TextField name="searchQuery" size="small" variant="outlined" placeholder={t("searchText")} value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
        sx={{ width: '200px', mt: 0.5 }} InputProps={{ sx: { fontSize: 13, padding: 0, height: 30, "& input": { padding: "0", paddingLeft: 1, height: "30px", }, }, }} />
      <div className='flex items-center justify-between' style={{ gap: "10px", marginRight: '10px' }}>
        <div className='text-sm mr-2' style={{ fontSize: '0.85rem', fontWeight: 700 }}> {t('balance')}: {(accountSummary?.balance || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </div>
        <div className='text-sm ' style={{ fontSize: '0.85rem', fontWeight: 700 }}> {t('credit')}: {(accountSummary?.credit || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </div>
        <div className='text-sm ' style={{ fontSize: '0.85rem', fontWeight: 700 }}> {t('floatingPL')}: {parseFloat(floatingPL).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </div>
        <div className='text-sm ' style={{ fontSize: '0.85rem', fontWeight: 700 }}> {t('equity')}: {calculatedEquity} </div>
        <div className='text-sm ' style={{ fontSize: '0.85rem', fontWeight: 700 }}> {t('usedMargin')}: {(accountSummary?.usedMargin || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </div>
        <div className='text-sm ' style={{ fontSize: '0.85rem', fontWeight: 700 }}> {t('freeMargin')}: {freeMargin} </div>
        <div className='text-sm ' style={{ fontSize: '0.85rem', fontWeight: 700 }}> {t('marginLevel')}: {calculatedMarginLevel}% </div>
      </div>

      {/* <div className='flex items-center opacity-50'>
        <small>{t('poweredby')} </small><a href="https://hybridsolutions.com/" target='_blank'><img src={imgSrc} alt="hs" style={{ height: darkMode ? 40 : 20 }} className='ms-2' />
        </a>
      </div> */}
    </div>
  );
}

export default AccountFooter;
